<template>
  <ot-info
    class="settlement-delay-info"
    :message="$t('ui.settlementDelay.message')"
  />
</template>
